import Axios from 'axios';
var GoodsBatchService = (function () {
    function GoodsBatchService() {
    }
    GoodsBatchService.prototype.getGoodsBatchList = function (params) {
        return Axios.post('supplierclientapi/goods_batch/delivery_goods_batch_list', params);
    };
    GoodsBatchService.createInstance = function () {
        GoodsBatchService.getInstance();
    };
    GoodsBatchService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return GoodsBatchService;
}());
export default GoodsBatchService;
